import { GET, POST, DELETE } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchDelegationRequest = () =>
  GET("delegation/byDelegator").pipe(map((response: any) => response));

export const fetchDeleteDelegationRequest = (id: number) =>
  DELETE(`delegation/${id}`).pipe(map((response: any) => response));

export const fetchModifyDelegation = (id: number, modifyDate: {}) =>
  POST(`delegation/${id}/extendValidity`, modifyDate).pipe(
    map((response: any) => response)
  );

export const fecthDelegableUserRequest = () =>
  GET("user/delegableUsers").pipe((response: any) => response);

export const fecthDelegableUserBAORequest = (ou: string) =>
  GET(`user/delegableUsers?ou=${ou}`).pipe((response: any) => response);

export const fetchCreateDelegation = (delegationOBJ: {}) =>
  POST("delegation", delegationOBJ).pipe(map((response: any) => response));
